<template>
	<div id="app">
    <nav-bar></nav-bar>
		<router-view />
	</div>
</template>

<script>
import NavBar from "./components/nav-bar/NavBar.vue";

export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>

<style>

html, body {
  margin: 0px;
  max-width: 100%;
  overflow-x: hidden;
  background-color: white;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
